export const en = {
    cancel: 'Cancel',
    'crop-title': 'Crop',
    'min-size': 'Selected area is less than 450 pixels on one side',
    'min-size-16-9': "The selected image can't be used in wide format — the image is less than 1080 × 607 pixels",
    'narrow-scale': 'The selected area is too narrow',
    save: 'Save',
    'standart-format': 'Standard image',
    tip: 'Select an area to display in the ad',
    'wide-format': 'Wide-format (16:9)',
    'wide-scale': 'The selected area is too wide'
};
